import DemoBanner from "./DemoBanner";

const projects = [
  {
    title: "Lumen House",
    location: "Portland, OR",
    image: "https://images.unsplash.com/photo-1775486134015-cedad4808fea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHxhcmNoaXRlY3R1cmFsJTIwaW50ZXJpb3IlMjBsaWdodCUyMHNoYWRvdyUyMGdlb21ldHJpYyUyMHNwYWNlfGVufDB8fHx8MTc3NjI4OTg0OHww&ixlib=rb-4.1.0&q=85",
    aspect: "aspect-[3/4]",
    offset: "",
  },
  {
    title: "The Prism Pavilion",
    location: "Marfa, TX",
    image: "https://images.unsplash.com/photo-1549791084-5f78368b208b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmUlMjBidWlsZGluZyUyMGNvbmNyZXRlJTIwbWluaW1hbHxlbnwwfHx8fDE3NzYyODk4MDd8MA&ixlib=rb-4.1.0&q=85",
    aspect: "aspect-[4/3]",
    offset: "lg:mt-32",
  },
  {
    title: "Fold Residence",
    location: "Hudson Valley, NY",
    image: "https://images.unsplash.com/photo-1774685110718-c5b4fe026144?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwyfHxyZXNpZGVudGlhbCUyMGFyY2hpdGVjdHVyZSUyMGV4dGVyaW9yJTIwbW9kZXJuJTIwaG91c2UlMjBkZXNpZ258ZW58MHx8fHwxNzc2Mjg5ODU4fDA&ixlib=rb-4.1.0&q=85",
    aspect: "aspect-[4/5]",
    offset: "",
  },
  {
    title: "Horizon Chapel",
    location: "Ojai, CA",
    image: "https://images.unsplash.com/photo-1768195176709-ed233289c267?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxhcmNoaXRlY3R1cmFsJTIwaW50ZXJpb3IlMjBsaWdodCUyMHNoYWRvdyUyMGdlb21ldHJpYyUyMHNwYWNlfGVufDB8fHx8MTc3NjI4OTg0OHww&ixlib=rb-4.1.0&q=85",
    aspect: "aspect-[3/2]",
    offset: "lg:mt-16",
  },
  {
    title: "Shore Studio",
    location: "Cape Elizabeth, ME",
    image: "https://images.unsplash.com/photo-1643036624745-dfb1a6dbedac?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmUlMjBidWlsZGluZyUyMGNvbmNyZXRlJTIwbWluaW1hbHxlbnwwfHx8fDE3NzYyODk4MDd8MA&ixlib=rb-4.1.0&q=85",
    aspect: "aspect-[16/10]",
    offset: "",
  },
];

const heading = {
  fontFamily: "'Libre Franklin', sans-serif",
  fontWeight: 300,
  letterSpacing: "0.1em",
};

const body = {
  fontFamily: "'DM Sans', sans-serif",
};

export default function ThresholdStudio() {
  return (
    <div data-testid="demo-threshold" style={body} className="bg-white text-[#0A0A0A] min-h-screen">

      {/* Hero */}
      <section className="relative h-screen min-h-[600px] overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1630908650794-e76619014675?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmUlMjBidWlsZGluZyUyMGNvbmNyZXRlJTIwbWluaW1hbHxlbnwwfHx8fDE3NzYyODk4MDd8MA&ixlib=rb-4.1.0&q=85"
          alt="Architectural detail"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/20" />

        {/* Studio name — centered, clean */}
        <div className="absolute inset-0 flex items-center justify-center">
          <h1
            style={{ ...heading, fontWeight: 200, letterSpacing: "0.25em" }}
            className="text-white text-4xl sm:text-5xl md:text-6xl lg:text-7xl uppercase"
          >
            Threshold Studio
          </h1>
        </div>

        {/* Minimal bottom nav */}
        <div className="absolute bottom-0 left-0 right-0 px-6 md:px-16 py-6 flex items-end justify-between">
          <span style={{ ...heading, letterSpacing: "0.2em" }} className="text-white/60 text-xs uppercase">
            Architecture &middot; Interiors
          </span>
          <span style={{ ...heading, letterSpacing: "0.2em" }} className="text-white/60 text-xs uppercase">
            Est. 2017
          </span>
        </div>
      </section>

      {/* Nav — minimal, appears after hero */}
      <nav className="px-6 md:px-16 py-8 flex items-center justify-between border-b border-[#0A0A0A]/8">
        <span style={{ ...heading, letterSpacing: "0.15em" }} className="text-base uppercase text-[#0A0A0A]">
          Threshold
        </span>
        <div className="flex items-center gap-8">
          <a href="#work" style={{ ...heading, letterSpacing: "0.12em" }} className="text-xs uppercase text-[#0A0A0A]/50 hover:text-[#0A0A0A] transition-colors">
            Work
          </a>
          <a href="#about" style={{ ...heading, letterSpacing: "0.12em" }} className="text-xs uppercase text-[#0A0A0A]/50 hover:text-[#0A0A0A] transition-colors">
            Studio
          </a>
          <a href="#contact" style={{ ...heading, letterSpacing: "0.12em" }} className="text-xs uppercase text-[#0A0A0A]/50 hover:text-[#0A0A0A] transition-colors">
            Contact
          </a>
        </div>
      </nav>

      {/* Project Gallery — asymmetric editorial layout */}
      <section id="work" className="px-6 md:px-16 py-24 md:py-40">
        <p style={{ ...heading, letterSpacing: "0.2em" }} className="text-xs uppercase text-[#B5846C] mb-20 md:mb-28">
          Selected Projects
        </p>

        {/* Asymmetric grid */}
        <div className="space-y-24 md:space-y-40">
          {/* Row 1 — large left, small right offset */}
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
            <div className="lg:col-span-7">
              <div className={`${projects[0].aspect} overflow-hidden group cursor-pointer`}>
                <img src={projects[0].image} alt={projects[0].title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.02]" />
              </div>
              <div className="mt-4 flex items-baseline justify-between">
                <span style={{ ...heading, letterSpacing: "0.06em" }} className="text-lg font-light">{projects[0].title}</span>
                <span style={heading} className="text-xs uppercase text-[#0A0A0A]/40">{projects[0].location}</span>
              </div>
            </div>
            <div className={`lg:col-span-5 ${projects[1].offset}`}>
              <div className={`${projects[1].aspect} overflow-hidden group cursor-pointer`}>
                <img src={projects[1].image} alt={projects[1].title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.02]" />
              </div>
              <div className="mt-4 flex items-baseline justify-between">
                <span style={{ ...heading, letterSpacing: "0.06em" }} className="text-lg font-light">{projects[1].title}</span>
                <span style={heading} className="text-xs uppercase text-[#0A0A0A]/40">{projects[1].location}</span>
              </div>
            </div>
          </div>

          {/* Row 2 — centered medium */}
          <div className="max-w-3xl mx-auto lg:ml-[15%] lg:mr-auto">
            <div className={`${projects[2].aspect} overflow-hidden group cursor-pointer`}>
              <img src={projects[2].image} alt={projects[2].title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.02]" />
            </div>
            <div className="mt-4 flex items-baseline justify-between">
              <span style={{ ...heading, letterSpacing: "0.06em" }} className="text-lg font-light">{projects[2].title}</span>
              <span style={heading} className="text-xs uppercase text-[#0A0A0A]/40">{projects[2].location}</span>
            </div>
          </div>

          {/* Row 3 — small left offset, large right */}
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
            <div className={`lg:col-span-4 ${projects[3].offset}`}>
              <div className={`${projects[3].aspect} overflow-hidden group cursor-pointer`}>
                <img src={projects[3].image} alt={projects[3].title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.02]" />
              </div>
              <div className="mt-4 flex items-baseline justify-between">
                <span style={{ ...heading, letterSpacing: "0.06em" }} className="text-lg font-light">{projects[3].title}</span>
                <span style={heading} className="text-xs uppercase text-[#0A0A0A]/40">{projects[3].location}</span>
              </div>
            </div>
            <div className="lg:col-span-8">
              <div className={`${projects[4].aspect} overflow-hidden group cursor-pointer`}>
                <img src={projects[4].image} alt={projects[4].title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.02]" />
              </div>
              <div className="mt-4 flex items-baseline justify-between">
                <span style={{ ...heading, letterSpacing: "0.06em" }} className="text-lg font-light">{projects[4].title}</span>
                <span style={heading} className="text-xs uppercase text-[#0A0A0A]/40">{projects[4].location}</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About — minimal */}
      <section id="about" className="px-6 md:px-16 py-24 md:py-32 border-t border-[#0A0A0A]/8">
        <div className="max-w-xl lg:ml-[25%]">
          <p style={{ ...heading, letterSpacing: "0.2em" }} className="text-xs uppercase text-[#B5846C] mb-8">
            Studio
          </p>
          <p style={{ fontFamily: "'Libre Franklin', sans-serif", fontWeight: 300 }} className="text-xl sm:text-2xl leading-relaxed text-[#0A0A0A]/60">
            Threshold Studio is a small architecture practice focused on
            residential and cultural projects. We design spaces where light,
            material, and proportion create quiet intensity. Every project begins
            with listening and ends with something worth inhabiting.
          </p>
        </div>
      </section>

      {/* Contact — minimal */}
      <section id="contact" className="px-6 md:px-16 py-24 md:py-32 border-t border-[#0A0A0A]/8">
        <div className="max-w-xl lg:ml-[25%]">
          <p style={{ ...heading, letterSpacing: "0.2em" }} className="text-xs uppercase text-[#B5846C] mb-10">
            Contact
          </p>
          <div className="space-y-4">
            <a
              href="mailto:hello@thresholdstudio.com"
              style={{ fontFamily: "'Libre Franklin', sans-serif", fontWeight: 300 }}
              className="block text-xl text-[#0A0A0A] hover:text-[#B5846C] transition-colors"
            >
              hello@thresholdstudio.com
            </a>
            <a
              href="tel:5035550192"
              style={{ fontFamily: "'Libre Franklin', sans-serif", fontWeight: 300 }}
              className="block text-xl text-[#0A0A0A]/50 hover:text-[#0A0A0A] transition-colors"
            >
              (503) 555-0192
            </a>
          </div>
        </div>
      </section>

      {/* Footer — barely there */}
      <footer className="px-6 md:px-16 py-10 border-t border-[#0A0A0A]/5">
        <span style={{ ...heading, letterSpacing: "0.12em" }} className="text-xs uppercase text-[#0A0A0A]/20">
          {new Date().getFullYear()} Threshold Studio
        </span>
      </footer>

      <div className="pb-16" />
      <DemoBanner />
    </div>
  );
}
